import type { ReactElement } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { CmarkdownLabelText } from '../Cmarkdowntext/CmarkdownLabelText';
import { getFontFamily } from '@/theme/typography';
import { DONUT_TRACK_WIDTH, PIECHART_CENTER_TEXT_ALIGN } from './piechart-constants';
import type { PieChartArc } from './piechart-types';
interface PieChartCenterLabelProps {
    arcs: ReadonlyArray<PieChartArc>;
    centerX: number;
    hoveredIndex: number | null;
    radius: number;
}
export function PieChartCenterLabel({ arcs, centerX, hoveredIndex, radius, }: PieChartCenterLabelProps): ReactElement {
    const hoveredArc = hoveredIndex == null ? null : arcs[hoveredIndex];
    return (
      <foreignObject x={centerX - radius + DONUT_TRACK_WIDTH} y={centerX - radius + DONUT_TRACK_WIDTH} width={(radius - DONUT_TRACK_WIDTH) * 2} height={(radius - DONUT_TRACK_WIDTH) * 2} style={{ pointerEvents: 'none' }}>
        <AnimatePresence mode="wait">
          {hoveredArc && (<PieChartCenterLabelContent hoveredArc={hoveredArc}/>)}
        </AnimatePresence>
      </foreignObject>
    );
}
interface PieChartCenterLabelContentProps {
    hoveredArc: PieChartArc;
}
function PieChartCenterLabelContent({ hoveredArc, }: PieChartCenterLabelContentProps): ReactElement {
    return (
      <motion.div key={hoveredArc.debugIdentity} initial={{ opacity: 0, scale: 0.85 }} animate={{ opacity: 1, scale: 1 }} exit={{ opacity: 0, scale: 0.85 }} transition={{ duration: 0.15, ease: [0.4, 0, 0.2, 1] }} style={{
            width: '100%',
            height: '100%',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            gap: 3,
        }}>
        <span style={{
            fontFamily: getFontFamily(),
            fontSize: 28,
            fontWeight: 600,
            color: hoveredArc.color,
            lineHeight: 1.1,
        }}>
          {hoveredArc.percentage}%
        </span>
        <CmarkdownLabelText content={hoveredArc.slice.label} size={16} textAlign={PIECHART_CENTER_TEXT_ALIGN} style={{ maxWidth: '90%', minWidth: 0 }} paragraphStyle={{ marginBottom: 0, minWidth: 0, justifyContent: 'center' }} textStyle={{
            color: 'rgba(255,255,255,0.6)',
            lineHeight: 1.2,
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
        }}/>
      </motion.div>
    );
}
